<template>
  <div class="dialog-container wt-dialog-container">
    <div v-loading="isUserDeliveryGarbageDetailLoading">
      <wt-readonly-form-section ref="formSection" :detail-form-data.sync="detailFormData" :detail-form.sync="detailForm" :readonly="true" >
        <template slot="garbageImg" slot-scope="data">
          <template v-if="detailFormData.garbageImg && detailFormData.garbageImg.length > 0">
       <!--     <img
              v-for="(item, index) in detailFormData.garbageImg.split(',')"
              :key="index"
              class="detail-img"
              :src="imgUrl + item" /> -->
              <el-image
                style="width: 100px; height: 100px;"
                v-for="(item, index) in detailFormData.garbageImg.split(',')"
                :src="imgUrl + item"
                :z-index="999"
                fit="cover"
                :key="index"
                :preview-src-list="[imgUrl + item]"></el-image>
          </template>
        </template>
        <template slot="proveImg" slot-scope="data">
          <template v-if="detailFormData.proveImg && detailFormData.proveImg.length > 0">
    <!--        <img
              v-for="(item, index) in detailFormData.proveImg.split(',')"
              :key="index"
              class="detail-img"
              :src="imgUrl + item" /> -->
              <el-image
                style="width: 100px; height: 100px;"
                v-for="(item, index) in detailFormData.proveImg.split(',')"
                :src="imgUrl + item"
                :z-index="999"
                fit="cover"
                :key="index"
                :preview-src-list="[imgUrl + item]"></el-image>
          </template>
        </template>
        <template slot="garbageWeight">
          <span style="margin-left: 13px;color: #333333;">{{ $wtUtil.transWeight(detailFormData.garbageWeight) }}</span>
        </template>
        <template slot="garbagePrice">
          <span style="margin-left: 13px;color: #333333;">{{ $wtUtil.transMoney(detailFormData.garbagePrice) }}</span>
        </template>
   <!--     <template slot="garbageTotalPrice">
          <span style="margin-left: 13px;color: #333333;">{{ $wtUtil.transMoney(detailFormData.garbageTotalPrice) }}</span>
        </template> -->
      </wt-readonly-form-section>
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'CustomerDeliveryGarbageView',
  props: ['component-type'],
  isAutoComponent: true,
  data() {
    return {
      imgUrl: window.wtConst.FILE_SERVER_URL,
      formCode: 'MODULES_USERDELIVERYGARBAGE',
      isSubmitLoading: false,
      formUpdateUrl: '/modules/userDeliveryGarbage/userDeliveryGarbageUpdate',
      formAddUrl: '/modules/userDeliveryGarbage/userDeliveryGarbageAdd',
      detailFormButtons: {
        title: '投递详情',
        elements: [{ name: '返回', key: 'CLOSE', action: 'CLOSE' }]
      },
      detailForm: {
        title: '投递详情',
        className: 'wt-section-long-content',
        elements: [
          { name: '用户昵称', key: 'name', type: 'text', className: 'wt-col-12', disabled: true },
          { name: '投递物品', key: 'garbageName', type: 'text', className: 'wt-col-12', disabled: true },
          { name: '投递总量（kg）', key: 'garbageWeight', type: 'custom', className: 'wt-col-12', disabled: true },
          { name: '单价(个)', key: 'garbagePrice', type: 'custom', className: 'wt-col-12', disabled: true },
          { name: '总积分(个)', key: 'garbageTotalPrice', type: 'text', className: 'wt-col-12', disabled: true },
          { name: '投递时间', key: 'createTime', type: 'text', className: 'wt-col-12', disabled: true },
          { name: '投递方式', key: 'vn-test3', type: 'text', disabled: true, className: 'wt-col-12' },
          { name: '社区', key: 'communityName', type: 'text', className: 'wt-col-12', disabled: true },
          { name: '操作人员', key: 'employeesUserName', type: 'text', className: 'wt-col-12', disabled: true },
          { name: '货物图片', key: 'garbageImg', type: 'custom', className: 'wt-col-12', disabled: true },
          { name: '结算证明', key: 'proveImg', type: 'custom', className: 'wt-col-12', disabled: true }]
      }
    }
  },
  created() {
    this.$store.dispatch('appendBreadcrumb', { meta: { title: '投递详情' }})
  },
  methods: {
    /*  ------------------------- 按钮  -------------------------  */
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$emit('on-dialog-action', 'close')
        this.$store.dispatch('removeBreadcrumb')
      }
    },
    /*  ------------------------- 网络请求  -------------------------  */
    onWtDialogClose() {
      this.$emit('on-dialog-action', 'close')
    }
  },
  computed: {
    ...mapState({
      isUserDeliveryGarbageDetailLoading: state => state.userDeliveryGarbage.isUserDeliveryGarbageDetailLoading,
      detailFormData: state => state.userDeliveryGarbage.userDeliveryGarbageDetailData
    })
  }
}
</script>

<style scoped>
.detail-img {
  width: 80px;
  height: 80px;
  margin-right: 20px;
}
</style>
